var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 29,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.846 1H7.154c-2 0-3.308 1.076-3.692 3.075L1 15.762v8.611a3.7 3.7 0 0 0 3.692 3.69h24.616A3.704 3.704 0 0 0 33 24.374v-8.61L30.538 4.074C30.154 2 28.77 1 26.846 1Z",
    stroke: "#D9D9D9",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 15.637h11.077c0 1.354.519 2.653 1.442 3.61A4.835 4.835 0 0 0 17 20.743a4.835 4.835 0 0 0 3.481-1.495 5.205 5.205 0 0 0 1.442-3.611H33",
    stroke: "#D9D9D9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTray);
export default __webpack_public_path__ + "static/media/tray.f783242faba8cd7a5a7092d268e41a0b.svg";
export { ForwardRef as ReactComponent };